import { render } from "./ControlPanelInbox.vue?vue&type=template&id=ca31bb94&scoped=true"
import script from "./ControlPanelInbox.vue?vue&type=script&lang=js"
export * from "./ControlPanelInbox.vue?vue&type=script&lang=js"

import "./ControlPanelInbox.vue?vue&type=style&index=0&id=ca31bb94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca31bb94"]])

export default __exports__